import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Drawer } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CrossIcon from '../../assets/pdp/crossIcon.svg';
import FAQIcon from '../../assets/pdp/faqIcon.svg';
import Faqs from '../TenureSelectorDrawer/Faq';

export type FAQProps = {
	details: Detail[];
	title?: string;
	isOpen: boolean;
	onClose: () => void;
};

export type Detail = {
	answer: string;
	question: string;
};

const FrequentlyAskedQuestions = (props: FAQProps) => {
	return (
		<Drawer open={props?.isOpen} anchor='right' onClose={() => props.onClose()}>
			<Box sx={{ padding: '80px', width: '600px' }}>
				<FlexBox
					sx={{ justifyContent: 'space-between', paddingBottom: '30px' }}
				>
					<FAQIcon />
					<Box onClick={() => props.onClose()} sx={{ cursor: 'pointer' }}>
						<CrossIcon />
					</Box>
				</FlexBox>
				<LencoTypography
					sx={{ ...getStyle('H9_Regular'), color: getColor('Gray 0') }}
				>
					Frequently Asked Questions
				</LencoTypography>
				<Faqs faqs={props} />
			</Box>
		</Drawer>
	);
};

export default FrequentlyAskedQuestions;
